import React, { useState, useEffect } from 'react';
// External imports
import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormGroup,
  FormControl,
  FormControlLabel,
  Input,
  Typography,
  withStyles,
} from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
// Styling imports
import { styles } from '~/app/Pages/Returns/components/Print/css/dialogStyles.js';
import './css/print.css';

const SuggestedPasswordDialog = props => {
  const { classes } = props;

  const [updatedPdfPassword, setUpdatedPdfPassword] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [tpEmail, setTpEmail] = useState('');
  const [spEmail, setSpEmail] = useState('');
  const [repEmail, setRepEmail] = useState('');
  const [tpSelected, setTpSelected] = useState(false);
  const [spSelected, setSpSelected] = useState(false);
  const [repSelected, setRepSelected] = useState(false);
  const [tpSelectedEPass, setTpSelectedEPass] = useState(false);
  const [spSelectedEPass, setSpSelectedEPass] = useState(false);
  const [repSelectedEPass, setRepSelectedEPass] = useState(false);
  const [tpSelectedText, setTpSelectedText] = useState(false);
  const [spSelectedText, setSpSelectedText] = useState(false);
  const [repSelectedText, setRepSelectedText] = useState(false);
  const [tpAllowText, setTpAllowText] = useState('');
  const [tpCellPhoneNumber, setTpCellPhoneNumber] = useState('');
  const [tpCellPhoneCarrier, setTpCellPhoneCarrier] = useState('');
  const [tpCellPhoneDomain, setTpCellPhoneDomain] = useState('');
  const [spAllowText, setSpAllowText] = useState('');
  const [spCellPhoneNumber, setSpCellPhoneNumber] = useState('');
  const [spCellPhoneCarrier, setSpCellPhoneCarrier] = useState('');
  const [spCellPhoneDomain, setSpCellPhoneDomain] = useState('');

  // Sync from props whenever the key identifying fields change (handles re-open from different contexts)
  useEffect(() => {
    setUpdatedPdfPassword(props.encryptedPwd.toUpperCase());
    setEmailSubject(props.encryptedTitle.toUpperCase());
    setTpEmail(props.taxpayerEmail.toUpperCase());
    setSpEmail(props.spouseEmail.toUpperCase());
    setRepEmail(props.preparerEmail.toUpperCase());
    setTpAllowText(props.tpAllowText);
    setTpCellPhoneNumber(props.tpCellPhoneNumber);
    setTpCellPhoneCarrier(props.tpCellPhoneCarrier);
    setTpCellPhoneDomain(props.tpCellPhoneDomain);
    setSpAllowText(props.spAllowText);
    setSpCellPhoneNumber(props.spCellPhoneNumber);
    setSpCellPhoneCarrier(props.spCellPhoneCarrier);
    setSpCellPhoneDomain(props.spCellPhoneDomain);
    // Reset checkboxes so the dialog is clean each time it is re-opened
    setTpSelected(false);
    setSpSelected(false);
    setRepSelected(false);
    setTpSelectedEPass(false);
    setSpSelectedEPass(false);
    setRepSelectedEPass(false);
    setTpSelectedText(false);
    setSpSelectedText(false);
    setRepSelectedText(false);
  }, [
    props.isOpen,
    props.encryptedPwd,
    props.encryptedTitle,
    props.taxpayerEmail,
    props.spouseEmail,
    props.preparerEmail,
    props.tpAllowText,
    props.tpCellPhoneNumber,
    props.tpCellPhoneCarrier,
    props.tpCellPhoneDomain,
    props.spAllowText,
    props.spCellPhoneNumber,
    props.spCellPhoneCarrier,
    props.spCellPhoneDomain,
  ]);

  const handleNewEncryptedPsw = () => {
    props.setEncryptedPassword(
      updatedPdfPassword,
      emailSubject,
      tpSelected,
      spSelected,
      repSelected,
      tpSelectedEPass,
      spSelectedEPass,
      repSelectedEPass,
      tpSelectedText,
      spSelectedText,
      repSelectedText,
    );
  };

  const optionsSelected =
    tpSelected ||
    spSelected ||
    repSelected ||
    tpSelectedEPass ||
    spSelectedEPass ||
    repSelectedEPass ||
    tpSelectedText ||
    spSelectedText ||
    repSelectedText;

  const taxpayerTextOption =
    tpCellPhoneNumber.length < 1 ||
    tpCellPhoneCarrier.length < 1 ||
    tpCellPhoneDomain.length < 1 ||
    tpAllowText.length < 1;

  const spouseTextOption =
    spCellPhoneNumber.length < 1 ||
    spCellPhoneCarrier.length < 1 ||
    spCellPhoneDomain.length < 1 ||
    spAllowText.length < 1;

  return (
    <React.Fragment>
      <DialogTitle
        className={classes.styledHeader}
        id="form-dialog-title"
        disableTypography
        style={{ minWidth: '400px' }}
      >
        <div style={{ display: 'inline-block', width: '92%' }}>
          <Typography
            style={{
              color: 'white',
              fontFamily: 'Roboto',
              fontSize: '18px',
              paddingTop: '4%',
              paddingLeft: '5%',
            }}
          >
            Email Encrypted PDF
          </Typography>
        </div>
        <div style={{ display: 'inline-block' }}>
          <Button
            className={classes.toolbarButtonRoot}
            style={{
              minWidth: '0',
              minHeight: '0',
              paddingLeft: '5px',
              paddingRight: '5px',
            }}
            onClick={props.handleClose}
          >
            X
          </Button>
        </div>
      </DialogTitle>
      <DialogContent style={{ paddingTop: '15px', paddingBottom: '10px' }}>
        <span id="spnSuggestedPswModal" style={{ paddingRight: '11px' }}>
          <div className="initial-block-encrypted-pdf">PDF Password:</div>
          <div className="encrypted-pdf">
            <div className="large-text-title-bar">
              <FormControl required>
                <Input
                  id="txtEncryptedPdfPassword"
                  name="updatedPdfPassword"
                  value={updatedPdfPassword}
                  onChange={e => setUpdatedPdfPassword(e.target.value.trim())}
                  className="email-pdf-mod-input"
                  disableUnderline
                />
              </FormControl>
            </div>
          </div>
          <div>
            <div className="initial-block-encrypted-pdf">Email Subject:</div>
            <div className="encrypted-pdf">
              <div className="large-text-title-bar">
                <FormControl required>
                  <Input
                    id="txtEncryptedPdfSubject"
                    name="emailSubject"
                    value={emailSubject}
                    onChange={e => setEmailSubject(e.target.value.toUpperCase())}
                    className="email-pdf-mod-input"
                    disableUnderline
                  />
                </FormControl>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>Email PDF Document to:</div>
          <div className="email-pdf-mod-div-space">
            <FormControl required component="fieldset">
              <FormGroup>
                <div style={{ marginTop: '0vh', marginBottom: '0vh' }}>
                  <div className="email-pdf-mod-div-1">
                    <div className="email-pdf-mod-div-2">
                      <FormControlLabel
                        label="Taxpayer"
                        className={classes.labelWidthStyleCheckbox}
                        control={
                          <Checkbox
                            className="email-pdf-mod-checkbox"
                            icon={
                              <CheckBoxOutlineBlankIcon
                                style={{ fontSize: 24 }}
                                color="secondary"
                              />
                            }
                            checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                            id="chkTpSelectedEncryptedPDF"
                            name="tpSelected"
                            checked={tpSelected}
                            onChange={e => setTpSelected(e.target.checked)}
                            inputProps={{ height: '20px', width: '20px' }}
                            disabled={tpEmail === ''}
                          />
                        }
                      />
                    </div>
                  </div>
                  {props.showSpouseOption && (
                    <div className="email-pdf-mod-div-3">
                      <div className="email-pdf-mod-div-2">
                        <FormControlLabel
                          label="Spouse"
                          className={classes.labelWidthStyleCheckbox}
                          control={
                            <Checkbox
                              className="email-pdf-mod-checkbox"
                              icon={
                                <CheckBoxOutlineBlankIcon
                                  style={{ fontSize: 24 }}
                                  color="secondary"
                                />
                              }
                              checkedIcon={
                                <CheckBoxIcon style={{ fontSize: 24 }} color="primary" />
                              }
                              id="chkSpSelectedEncryptedPDF"
                              name="spSelected"
                              checked={spSelected}
                              onChange={e => setSpSelected(e.target.checked)}
                              inputProps={{ height: '20px', width: '20px' }}
                              disabled={spEmail === ''}
                            />
                          }
                        />
                      </div>
                    </div>
                  )}
                  <div className="email-pdf-mod-div-3">
                    {false && repEmail !== '' && (
                      <div className="email-pdf-mod-div-2">
                        <FormControlLabel
                          label="Representative"
                          className={classes.labelWidthStyleCheckbox}
                          control={
                            <Checkbox
                              className="email-pdf-mod-checkbox"
                              icon={
                                <CheckBoxOutlineBlankIcon
                                  style={{ fontSize: 24 }}
                                  color="secondary"
                                />
                              }
                              checkedIcon={
                                <CheckBoxIcon style={{ fontSize: 24 }} color="primary" />
                              }
                              id="chkReppSelectedEncryptedPDF"
                              name="repSelected"
                              checked={repSelected}
                              onChange={e => setRepSelected(e.target.checked)}
                              inputProps={{ height: '20px', width: '20px' }}
                              disabled={repEmail === ''}
                            />
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </FormGroup>
            </FormControl>
          </div>
          <div style={{ marginTop: '10px' }}>Email Password to:</div>
          <div className="email-pdf-mod-div-space">
            <FormControl required component="fieldset">
              <FormGroup>
                <div style={{ marginTop: '0vh', marginBottom: '0vh' }}>
                  <div className="email-pdf-mod-div-1">
                    <div className="email-pdf-mod-div-2">
                      <FormControlLabel
                        label="Taxpayer"
                        className={classes.labelWidthStyleCheckbox}
                        control={
                          <Checkbox
                            className="email-pdf-mod-checkbox"
                            icon={
                              <CheckBoxOutlineBlankIcon
                                style={{ fontSize: 24 }}
                                color="secondary"
                              />
                            }
                            checkedIcon={<CheckBoxIcon style={{ fontSize: 24 }} color="primary" />}
                            id="chkTpSelectedEmailPass"
                            name="tpSelectedEPass"
                            checked={tpSelectedEPass}
                            onChange={e => setTpSelectedEPass(e.target.checked)}
                            inputProps={{ height: '20px', width: '20px' }}
                            disabled={tpEmail === '' || updatedPdfPassword === ''}
                          />
                        }
                      />
                    </div>
                  </div>
                  {props.showSpouseOption && (
                    <div className="email-pdf-mod-div-3">
                      <div className="email-pdf-mod-div-2">
                        <FormControlLabel
                          label="Spouse"
                          className={classes.labelWidthStyleCheckbox}
                          control={
                            <Checkbox
                              className="email-pdf-mod-checkbox"
                              icon={
                                <CheckBoxOutlineBlankIcon
                                  style={{ fontSize: 24 }}
                                  color="secondary"
                                />
                              }
                              checkedIcon={
                                <CheckBoxIcon style={{ fontSize: 24 }} color="primary" />
                              }
                              id="chkSpSelectedEmailPass"
                              name="spSelectedEPass"
                              checked={spSelectedEPass}
                              onChange={e => setSpSelectedEPass(e.target.checked)}
                              inputProps={{ height: '20px', width: '20px' }}
                              disabled={spEmail === '' || updatedPdfPassword === ''}
                            />
                          }
                        />
                      </div>
                    </div>
                  )}
                  <div className="email-pdf-mod-div-3">
                    {false && repEmail !== '' && (
                      <div className="email-pdf-mod-div-2">
                        <FormControlLabel
                          label="Representative"
                          className={classes.labelWidthStyleCheckbox}
                          control={
                            <Checkbox
                              className="email-pdf-mod-checkbox"
                              icon={
                                <CheckBoxOutlineBlankIcon
                                  style={{ fontSize: 24 }}
                                  color="secondary"
                                />
                              }
                              checkedIcon={
                                <CheckBoxIcon style={{ fontSize: 24 }} color="primary" />
                              }
                              id="chkReppSelectedEmailPass"
                              name="repSelectedEPass"
                              checked={repSelectedEPass}
                              onChange={e => setRepSelectedEPass(e.target.checked)}
                              inputProps={{ height: '20px', width: '20px' }}
                              disabled={repEmail === '' || updatedPdfPassword === ''}
                            />
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </FormGroup>
            </FormControl>
          </div>
          {props.isTextLinkOn && <div style={{ marginTop: '10px' }}>Text Password to:</div>}
          {props.isTextLinkOn && (
            <div className="email-pdf-mod-div-space">
              <FormControl required component="fieldset">
                <FormGroup>
                  <div style={{ marginTop: '0vh', marginBottom: '0vh' }}>
                    <div className="email-pdf-mod-div-1">
                      <div className="email-pdf-mod-div-2">
                        <FormControlLabel
                          label="Taxpayer"
                          className={classes.labelWidthStyleCheckbox}
                          control={
                            <Checkbox
                              className="email-pdf-mod-checkbox"
                              icon={
                                <CheckBoxOutlineBlankIcon
                                  style={{ fontSize: 24 }}
                                  color="secondary"
                                />
                              }
                              checkedIcon={
                                <CheckBoxIcon style={{ fontSize: 24 }} color="primary" />
                              }
                              id="chkTpSelectedTextEncryptedPDF"
                              name="tpSelectedText"
                              checked={tpSelectedText}
                              onChange={e => setTpSelectedText(e.target.checked)}
                              inputProps={{ height: '20px', width: '20px' }}
                              disabled={taxpayerTextOption || updatedPdfPassword === ''}
                            />
                          }
                        />
                      </div>
                    </div>
                    {props.showSpouseOption && (
                      <div className="email-pdf-mod-div-3">
                        <div className="email-pdf-mod-div-2">
                          <FormControlLabel
                            label="Spouse"
                            className={classes.labelWidthStyleCheckbox}
                            control={
                              <Checkbox
                                className="email-pdf-mod-checkbox"
                                icon={
                                  <CheckBoxOutlineBlankIcon
                                    style={{ fontSize: 24 }}
                                    color="secondary"
                                  />
                                }
                                checkedIcon={
                                  <CheckBoxIcon style={{ fontSize: 24 }} color="primary" />
                                }
                                id="chkSpSelectedTextEncryptedPDF"
                                name="spSelectedText"
                                checked={spSelectedText}
                                onChange={e => setSpSelectedText(e.target.checked)}
                                inputProps={{ height: '20px', width: '20px' }}
                                disabled={spouseTextOption || updatedPdfPassword === ''}
                              />
                            }
                          />
                        </div>
                      </div>
                    )}
                    <div className="email-pdf-mod-div-3">
                      {false && repEmail !== '' && (
                        <div className="email-pdf-mod-div-2">
                          <FormControlLabel
                            label="Representative"
                            className={classes.labelWidthStyleCheckbox}
                            control={
                              <Checkbox
                                className="email-pdf-mod-checkbox"
                                icon={
                                  <CheckBoxOutlineBlankIcon
                                    style={{ fontSize: 24 }}
                                    color="secondary"
                                  />
                                }
                                checkedIcon={
                                  <CheckBoxIcon style={{ fontSize: 24 }} color="primary" />
                                }
                                id="chkReppSelectedTextEncryptedPDF"
                                name="repSelectedText"
                                checked={repSelectedText}
                                onChange={e => setRepSelectedText(e.target.checked)}
                                inputProps={{ height: '20px', width: '20px' }}
                                disabled={repEmail === '' || updatedPdfPassword === ''}
                              />
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </FormControl>
            </div>
          )}
          <div
            style={{
              paddingLeft: '0px',
              marginLeft: '0px',
              border: 'none',
            }}
          >
            <Button
              id="btnErrorModalCloseSuggestedPassword"
              style={{
                paddingLeft: '0px',
                marginLeft: '0px',
                border: 'none',
              }}
              onClick={props.handleOptionNotAvailable}
            >
              Desired Option to Email Attached Document Not Available?
            </Button>
          </div>
        </span>
      </DialogContent>
      <DialogActions style={{ paddingRight: '0.5vw', paddingBottom: '0.5vh' }}>
        <Button
          onClick={props.handleClose}
          id="btnCancelSuggestedPsw"
          color="primary"
          className={classes.cancelButtonRoot}
        >
          Cancel
        </Button>
        <Button
          onClick={handleNewEncryptedPsw}
          id="btnOKSuggestedPsw"
          color="primary"
          disabled={!optionsSelected}
        >
          OK
        </Button>
      </DialogActions>
    </React.Fragment>
  );
};

export default withStyles(styles)(SuggestedPasswordDialog);
